/**
 * Defines the selection behavior of the AnalyticalTable.
 */
export let AnalyticalTableSelectionBehavior = /*#__PURE__*/function (AnalyticalTableSelectionBehavior) {
  AnalyticalTableSelectionBehavior["Row"] = "Row";
  AnalyticalTableSelectionBehavior["RowOnly"] = "RowOnly";
  AnalyticalTableSelectionBehavior["RowSelector"] = "RowSelector";
  return AnalyticalTableSelectionBehavior;
}({});